import * as styles from './styles';
import { title } from './constants';

import {
  Placeholder,
  PlaceholderChecklistsIcon,
} from '@cobliteam/base-components';

import { Button } from '@cobliteam/ui/components';

import AddRoundedIcon from '@material-ui/icons/AddRounded';

import { TabPanelOptions } from '../../constants';

export interface EmptyStateProps {
  onClick: () => void;
  selectedPanel: TabPanelOptions;
  hasFilteredChecklists: boolean;
}

export const EmptyState = ({
  onClick,
  selectedPanel,
  hasFilteredChecklists,
}: EmptyStateProps) => (
  <Placeholder
    className={styles.placeholder}
    text={
      hasFilteredChecklists && selectedPanel === TabPanelOptions.RECEIVED_LISTS
        ? title.NO_FILTER_RESULTS
        : title[selectedPanel]
    }
    Icon={PlaceholderChecklistsIcon}
  >
    {selectedPanel === TabPanelOptions.CREATED_LISTS ? (
      <Button startIcon={<AddRoundedIcon />} onClick={onClick}>
        Criar Checklist
      </Button>
    ) : null}
  </Placeholder>
);

export default EmptyState;
